/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IVaccinationSchedule } from 'app/shared/model/vaccination-schedule.model';
import { IVaccination } from 'app/shared/model/vaccination.model';

export interface IVaccinationScheduleDetails {
  id?: string;
  active?: boolean;
  ageMax?: number;
  ageMin?: number;
  country?: string | null;
  dosage?: string | null;
  gender?: string | null;
  periodInDays?: number;
  risk?: string | null;
  vaccinationTypeCd?: string | null;
  forYear?: number | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  schedule?: IVaccinationSchedule;
  vacciantion?: IVaccination;
}

export const defaultValue: Readonly<IVaccinationScheduleDetails> = {
  active: false,
};
